import {DesktopDatePicker, type DesktopDatePickerProps} from '@mui/x-date-pickers';
import useLanguage from 'hooks/useLanguage';
import {LocalizationComponent} from './LocalizationComponent';
import {styled, TextField} from '@mui/material';

export const TablesDatePicker = (props: DesktopDatePickerProps<Date>) => {
  const slotProps = {
    ...props?.slotProps,
  };
  const {dateFormatter} = useLanguage();
  return (
    <LocalizationComponent>
      <DesktopDatePicker
        {...props}
        slots={{
          textField: StyledTextField,
        }}
        slotProps={{
          ...slotProps,
          textField: {
            ...slotProps.textField,
            variant: 'standard',
            size: 'small',
          },
          openPickerIcon: {color: 'secondary', size: 'small'},
        }}
        displayWeekNumber={true}
        format={dateFormatter.getDateFormat()}
      />
    </LocalizationComponent>
  );
};

const StyledTextField = styled(TextField)({
  '& .MuiInput-underline:before': {
    borderBottom: 'none!important',
    padding: 0,
    paddingTop: 0,
  },
  '& .MuiInput-underline:after': {
    borderBottom: 'none',
  },
  '& .MuiInput-underline:hover:before': {
    borderBottom: 'none',
  },
  '& .MuiInput-underline:hover': {
    borderBottom: 'none',
  },
});
